// 3510QueryYB.js - 医保采购信息查询接口 (3510)
import { ybRequestTemplate } from "/src/untils/ybRequestTemplate.js"
import { addYbRquestData, getqdNo } from "@/api/yb";
import axios from "axios";
import dayjs from "dayjs";

/**
 * 辅助方法：判断是否为处方药（根据药品名称或编码简单判断)
 * @param {object} row - 行数据对象
 * @returns {string} 1表示处方药，0表示非处方药
 */
const getRxFlag = (row) => {
	const rxKeywords = ['抗生素', '麻醉', '精神', '处方', 'RX'];
    const drugName = row.fixmedinsHilistName || '';
	
    return rxKeywords.some(keyword => drugName.includes(keyword)) ? '1' : '0';
};
/**
 * 医保采购信息查询接口 (3510)
 * @param {Object} row - 要查询的行数据
 * @param {Object} userData - 用户信息
 * @param {Object} clinicInfo - 诊所信息
 * @param {String} startTime - 开始时间
 * @param {String} endTime - 结束时间
 * @param {Function} addStepMessage - 添加步骤消息的函数
 * @param {Function} addOperationStepMessage - 添加操作步骤消息的函数
 * @param {Function} updateOperationProgress - 更新进度条的函数
 * @param {Function} updateOperationStepStatus - 更新步骤状态的函数
 * @returns {Promise} 查询结果
 */
export const queryMedicalInsuranceStorage3510 = async (
  row, 
  userData, 
  clinicInfo, 
  startTime,
  endTime,
  addStepMessage, 
  addOperationStepMessage, 
  updateOperationProgress,
  updateOperationStepStatus
) => {
  try {
    addStepMessage('开始执行医保库存信息查询流程(3510)...');
    
    // 准备查询请求数据
    addOperationStepMessage('准备查询请求数据...');
    const ybRequest = JSON.parse(JSON.stringify(ybRequestTemplate));
    const today = dayjs().format('YYYY-MM-DD');
    
    // 获取签到编号
    const signNoRes = await getqdNo();
    let signNo = '';
    if (signNoRes.code === 200) {
      signNo = signNoRes.data.signNo;
      addStepMessage(`签到业务ID: ${signNo}`);
    } else {
      throw new Error('获取签到流水号失败');
    }
    
	const rxFlag = getRxFlag(row);
	addStepMessage(`药品处方药标识判断：${rxFlag === '1'? '处方药' : '非处方药'}`);
    // 设置请求参数 - 3510接口
    ybRequest.body.infno = '3510';
    ybRequest.body.msgid = `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${getRandom4Digits()}`;
    ybRequest.body.insuplc_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.mdtrtarea_admvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_sys_code = '007';
    ybRequest.body.infver = 'V1.049';
    ybRequest.body.opter_type = '1';
    ybRequest.body.opter = userData.userId || '1';
    ybRequest.body.opter_name = userData.staffName || '系统操作员';
    ybRequest.body.inf_time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    ybRequest.body.fixmedins_code = userData.clinicCode || '';
    ybRequest.body.fixmedins_name = userData.clinicName || '';
    ybRequest.body.sign_no = signNo;
    
	// 格式化时间参数
	const formattedStartTime = startTime ? dayjs(startTime).format('YYYY-MM-DD') : '';
	const formattedEndTime = endTime ? dayjs(endTime).format('YYYY-MM-DD') : '';
    // 设置查询数据 - 根据3510接口规范
    ybRequest.body.input.data = {
		fixmedins_code: row.medListCodg || '',  // 定点医药机构编号
		medins_prod_inv_no: row.prod_inv_no || '', // 医药机构目录编码
		fixmedins_bchno: row.fixmedinsBcHNo || '',  // 定点医药机构批次流水号
		
		begndate:formattedStartTime, // 开始日期
		enddate:formattedEndTime, // 结束日期
		medins_prod_inv_no: row.prod_inv_no || '',
		med_list_codg: row.medListCodg || '', // 医疗目录编码
		
		medins_list_name: row.fixmedinsHilistId || '',
		rx_flag: rxFlag || '0',
		
		list_sp_item_flag: '1' || '',
		trdn_flag: 0 || '',

		invdate: '',
		manu_lotnum: row.manuLotnum || '',
		manu_date:row.manuDate || '',
		expy_date:row.expyDate || '',
		memo: row.remark || `采购单号: ${row.jyCode || '无单号'}`,
		vali_flag: '0',
		rid:'',
		crter_id: userData.userId || '1',
		crter_name: userData.staffName || 'admin',
		crte_optins_no: '',
		opter_id: userData.userId || '1',
		opter_name: userData.staffName || 'admin',
		optins_no: '',
		poolarea_no: '',
    };
    
    addStepMessage('准备调用接口查询库存信息(3510)...');
    
    // 先传给系统
    const newItem = {
      infno: 3510,
      mdtrtareaAdmvs: userData.mdtrtareaAdmvs || '',
      data: JSON.stringify(ybRequest.body),
      patientId: userData.staffId || '',
      patientName: userData.staffName || '系统操作员'
    };
    
    const res = await addYbRquestData(newItem);
    
    if (res.code !== 200) {
      throw new Error('医保查询数据准备失败: ' + res.message);
    }
    
    addStepMessage('医保查询数据准备完成，开始调用接口(3510)...');
    
    let responseData = res.data;
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (parseError) {
        throw new Error('解析医保响应数据失败');
      }
    }
    
    // 设置请求头
    ybRequest.headers.infosyscode = responseData.infosyscode || '';
    ybRequest.headers.hsf_signature = responseData.signature || '';
    ybRequest.headers.fixmedins_code = userData.clinicCode || '';
    ybRequest.headers.hsf_nonce = responseData.hsfNonce || '';
    ybRequest.headers.hsf_timestamp = responseData.hsfTimestamp || '';
    
    addStepMessage('调用医保库存信息查询接口(3510)...');
    updateOperationProgress(70);
    updateOperationStepStatus(1, 'loading');
    
    // 调用医保接口
    const axiosConfig = {
      method: 'post',
      url: process.env.VUE_APP_BASE_YBHOST + `/eapdomain/callService`,
      baseURL: '',
      headers: ybRequest.headers,
      data: ybRequest.body,
    };
    
    const response = await axios(axiosConfig);
    const result = response.data || response;
    
    // 处理响应结果
    if (result.infcode === 0) {
      addStepMessage('医保库存信息查询成功(3510)', { level: 'success' });
      updateOperationProgress(100);
      updateOperationStepStatus(1, 'success');
      
      // 处理查询结果数据
      if (result.output && result.output.data) {
        addStepMessage(`查询到 ${result.output.data.length} 条库存信息`, { level: 'success' });
      }
      
      return result;
    } else {
      let errorMsg = '医保库存信息查询失败(3510)';
      if (result) {
        errorMsg = result.err_msg || result.msg || result.message || '未知错误';
      }
      throw new Error(errorMsg);
    }
    
  } catch (error) {
    console.error('调用医保库存信息查询接口(3510)异常:', error);
    updateOperationProgress(100);
    updateOperationStepStatus(1, 'error');
    throw error;
  }
};



/**
 * 生成4位随机数
 * @returns {string} 4位随机数字
 */
const getRandom4Digits = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

export default {
  queryMedicalInsuranceStorage3510,
  getRxFlag
};